export default {
    name: "experience-tab",
    props: {
        input: Object
    }
}